import React, {useEffect, useState} from "react";
import "./Footer.scss";
import Information from "../../assets/images/information.svg";
import SocialIcons1 from "../../assets/images/SocialIcons1.svg";
import SocialIcons2 from "../../assets/images/SocialIcons2.svg";
import SocialIcons3 from "../../assets/images/SocialIcons3.svg";
import SocialIcons4 from "../../assets/images/SocialIcons4.svg";
import {Link, useNavigate} from "react-router";
import {getSpecialityApi} from "../../services/apiService";
import {useUserContext} from "../../context/UserContext";
import {toast} from "react-toastify";

const Footer = () => {
  const {setSearchValuesContext} = useUserContext();

  const navigate = useNavigate();

  const [specialityList, setSpecialityList] = useState();
  const [popularSearchList, setPopularSearchList] = useState();

  const getSpeciality = async () => {
    try {
      let response = await getSpecialityApi();
      if (response) {
        if (response.data.res === true) {
          const newChunks = [];
          for (let i = 0; i < response.data.data.length; i += 10) {
            newChunks.push(response.data.data.slice(i, i + 10));
          }
          setSpecialityList(newChunks);
          let tempArray = response.data.doctors_specilaties || [];
          if (tempArray.length < 10) {
            const existingNames = new Set(tempArray.map(item => item.name));
            response.data.data.forEach(item => {
              if (!existingNames.has(item.name) && tempArray.length < 10) {
                tempArray.push(item);
                existingNames.add(item.name);
              }
            });
          }
          setPopularSearchList(tempArray || []);
        } else {
          toast.error(response.data.msg, {autoClose: 1500});
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong in server. Please try again.", {
        autoClose: 1500,
      });
    }
  };

  const handleFooterLink = item => {
    let tempSearchValue = {};
    tempSearchValue.type = "speciality";
    if (item?.name) {
      tempSearchValue.specialityName = item?.name;
    }
    if (item?.id) {
      tempSearchValue.specialityId = item?.id;
    }
    sessionStorage.setItem("doctolikHomeSearchValue", JSON.stringify(tempSearchValue));
    setSearchValuesContext(tempSearchValue);
    navigate("/search-listing");
  };

  useEffect(() => {
    getSpeciality();
  }, []);

  return (
    <div className="Footer">
      <div className="FooterContainer">
        <div className="FooterTop">
          <div className="FooterTopLft">
            <h5>A question ? Need help ?</h5>
            <p>Visit our Help Center or contact us</p>
          </div>
          <button className="HelpBtn" onClick={() => navigate("/contact-us")}>
            <img src={Information} className="Downarrow" alt="icon" />
            OPEN HELP CENTER
          </button>
        </div>
        <div className="FooterBox">
          <div className="FooterBox1">
            <h4>Our enterprise</h4>
            <ul>
              {/* <li>
                <Link>About Us</Link>
              </li> */}
              <li>
                <Link>Video consultation</Link>
              </li>
              <li>
                <Link>Careers</Link>
              </li>
              <li>
                <Link>Press</Link>
              </li>
              <li>
                <Link to={"/contact-us"}>Need help ?</Link>
              </li>
              <li>
                <Link>Fraudulent notifications</Link>
              </li>
            </ul>

            <h4>For practitioners</h4>
            <ul>
              <li>
                <Link>Doctolik Pro management software</Link>
              </li>
              <li>
                <Link>Video consultation</Link>
              </li>
              <li>
                <Link>Doctolik Community</Link>
              </li>
            </ul>
          </div>
          <div className="FooterBox1">
            <h4>Find your specialist</h4>
            <ul>
              {specialityList &&
                specialityList[0]?.map((item, index) => (
                  <li key={index}>
                    <button onClick={() => handleFooterLink(item)}>{item?.name}</button>
                  </li>
                ))}
            </ul>
          </div>
          <div className="FooterBox1 FooterBox2">
            <h4>&nbsp; </h4>
            <ul>
              {specialityList &&
                specialityList[1]?.map((item, index) => (
                  <li key={index}>
                    <button onClick={() => handleFooterLink(item)}>{item?.name}</button>
                  </li>
                ))}
            </ul>
          </div>
          <div className="FooterBox1">
            <h4>Popular searches</h4>
            <ul>
              {popularSearchList &&
                popularSearchList?.map((item, index) => (
                  <li key={index}>
                    <button onClick={() => handleFooterLink(item)}>{item?.name}</button>
                  </li>
                ))}
            </ul>
          </div>
        </div>
        <div className="FooterBottom">
          <h5>Visit our Help Center or contact us</h5>
          <div className="socialicon">
            <ul>
              <li>
                <Link>
                  {" "}
                  <img src={SocialIcons1} className="Sicon" alt="icon" />
                </Link>
              </li>
              <li>
                <Link>
                  {" "}
                  <img src={SocialIcons2} className="Sicon" alt="icon" />
                </Link>
              </li>
              <li>
                <Link>
                  {" "}
                  <img src={SocialIcons3} className="Sicon" alt="icon" />
                </Link>
              </li>
              <li>
                <Link>
                  {" "}
                  <img src={SocialIcons4} className="Sicon" alt="icon" />
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
